export const GO_TO_PLAN_BUTTON = "GO_TO_PLAN_BUTTON";
export const HOW_TO_BOOK_APPOINTMENT = "HOW_TO_BOOK_APPOINTMENT";
export const Claims_Updates = "Claims_Updates";